import {
  IconButton,
  Typography,
  Box,
  useMediaQuery,
  Button,
  Grid,
} from "@mui/material";
import { getAppLinks } from "@/utils/getAppLinks";

const AppButtons = () => {
  const isLargeScreen = useMediaQuery(
    "(min-width: 375px) and (max-width: 900px)"
  );

  const appLinks = getAppLinks(isLargeScreen);

  return (
    <Box mb={{ xs: 7 }} maxWidth={{ xs: "auto", md: 124 }}>
      <Typography
        variant="subtitle1"
        component="p"
        mb={{ xs: 2, md: 2.75 }}
        fontWeight={700}
        color="white"
      >
        Get the App
      </Typography>

      <Grid container mb={{ xs: 2.5, md: 0 }} spacing={2}>
        {appLinks.map(({ AppIcon, href }, index) => (
          <Grid key={index} item xs={6} sm={4} md={12}>
            {!isLargeScreen ? (
              <IconButton
                component="a"
                target="_blank"
                href={href}
                sx={{ padding: 0 }}
              >
                <AppIcon />
              </IconButton>
            ) : (
              <Button
                component="a"
                target="_blank"
                href={href}
                key={index}
                fullWidth
                sx={{ padding: 0, border: "1px solid white" }}
              >
                <AppIcon />
              </Button>
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AppButtons;
